(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[484],{

/***/ 3308:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special-offers/group",
      function () {
        return __webpack_require__(5873);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ GroupOffers; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var _components_special_offers_SectionOffer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3784);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9536);
/* harmony import */ var _layout_Footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3981);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4850);






var __N_SSG = true;
function GroupOffers(param) {
    var header = param.header, hotelBrands = param.hotelBrands;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: "Group Offers | Parador Hotels & Resorts"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                headerItem: header,
                isHomepage: false,
                hotelBrands: hotelBrands
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_special_offers_SectionOffer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                isGroupOffer: true,
                limit: 0,
                isMainPage: true,
                isParador: true,
                hotelCode: header.hotel_code
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                h: 10
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Footer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                loc: header.location_url,
                address: header.location_long,
                email: header.email,
                phone: header.phone
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,9996,4939,3981,3784,9774,2888,179], function() { return __webpack_exec__(3308); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);